module.exports = global["svg4everybody"] = require("-!.\\svg4everybody.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?svg4everybody!./node_modules/svg4everybody/dist/svg4everybody.js-exposed
// module id = 119
// module chunks = 22